var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 8,
    cy: 8,
    r: 8,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2706 9.33285H8.509C8.365 7.99845 10.4578 7.83525 10.4578 6.42405C10.4578 5.14725 9.4402 4.50405 8.0482 4.50405C7.021 4.50405 6.1762 4.96485 5.5714 5.67525L6.3586 6.40485C6.829 5.90565 7.2994 5.64645 7.8946 5.64645C8.6434 5.64645 9.1042 5.97285 9.1042 6.54885C9.1042 7.48005 7.069 7.82565 7.2706 9.33285ZM7.8946 11.8864C8.3842 11.8864 8.7394 11.5408 8.7394 11.0416C8.7394 10.5328 8.3842 10.1872 7.8946 10.1872C7.4146 10.1872 7.0498 10.5328 7.0498 11.0416C7.0498 11.5408 7.405 11.8864 7.8946 11.8864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.6a39cc63a7b47c0faa56edca7682fa0e.svg";
export { ForwardRef as ReactComponent };